import React, { useState } from "react";
import { InputGroup } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { api } from "../../../../../services/Security/api";

interface Props {
	form: UseFormReturn<any>;
	name: string;
	prefix: string;
	disabled?: boolean;
}

const TaxIdNoWithGusInput = ({ form, name, prefix, disabled }: Props) => {
	const [loading, setLoading] = useState(false);
	const { addFlash } = useFlash();
	const {
		setValue,
		getValues,
		setError,
		clearErrors,
		register,
		formState: { errors },
	} = form;

	const onSearchClient = async () => {
		setLoading(true);
		const taxIdNo: string = getValues(name);
		try {
			const res = await api.getClientDataByTaxIdNo(taxIdNo);
			const data = res.data.data;
			setValue("company_name", data.name);
			setValue(`${prefix}country`, data.address_country);
			setValue(`${prefix}zip_code`, data.address_zip_code);
			setValue(`${prefix}city`, data.address_city);
			setValue(`${prefix}build_nr`, data.address_build_nr);
			setValue(`${prefix}flat_nr`, data.address_flat_nr);
			setValue(`${prefix}street`, data.address_street);
			clearErrors(name);
		} catch (err) {
			if (name === "tax_id_no") {
				handleError.form(err, setError, addFlash);
			} else {
				addFlash({
					type: "danger",
					msg: "contact_not_exists",
				});
			}
		}
		setLoading(false);
	};

	const { t } = useTranslation("admin");
	return (
		<InputGroup className="form-input-group">
			<FormInput
				name={name}
				disabled={disabled}
				label={t("lib:common.word.tax_id_no.title")}
				register={register}
				errors={errors}
			/>
			<div className="input-group-append">
				<ButtonLoading
					disabled={disabled}
					loading={loading}
					style={{ height: "31px", border: "1px solid #ced4da" }}
					onClick={() => onSearchClient()}
					variant={"primary"}
				>
					{t("lib:common.word.tax_id_no.search")}
				</ButtonLoading>
			</div>
		</InputGroup>
	);
};
export default TaxIdNoWithGusInput;
